export type IocQueryId = "recent" | "new";

export interface IocQueryDefinition {
  id: IocQueryId;
  label: string;
  limit: number;
  /** ||-delimited workflow status ids for GET .../encounter/keys; omit for unfiltered keys */
  workflowStatusIds?: string;
}

/** New status id in PE workflow (pre-convert New). */
export const WORKFLOW_STATUS_NEW = 13;

/** Board-friendly default page size for keys + full PE fetch. */
export const IOC_BOARD_QUERY_LIMIT = 50;

export const IOC_QUERIES: IocQueryDefinition[] = [
  {
    id: "recent",
    label: "Recent",
    limit: IOC_BOARD_QUERY_LIMIT,
  },
  {
    id: "new",
    label: "New",
    limit: IOC_BOARD_QUERY_LIMIT,
    workflowStatusIds: String(WORKFLOW_STATUS_NEW),
  },
];

export const DEFAULT_IOC_QUERY_ID: IocQueryId = "recent";

export function getIocQueryById(id: IocQueryId): IocQueryDefinition {
  const query = IOC_QUERIES.find((q) => q.id === id);
  if (!query) {
    return IOC_QUERIES[0];
  }
  return query;
}

/**
 * When a query has no workflowStatusIds (e.g. Recent), fill with ||-joined
 * primary status ids from metadata so the board can place cards.
 */
export function resolveIocQueryForBoard(
  query: IocQueryDefinition,
  statusIdsJoined: string
): IocQueryDefinition {
  if (query.workflowStatusIds) {
    return query;
  }
  if (!statusIdsJoined) {
    return query;
  }
  return {
    ...query,
    workflowStatusIds: statusIdsJoined,
  };
}
